<template>
  <v-content class="full-height">
    <v-container fluid grid-list-md id="home" class="listar" v-if="loaded">
      <v-layout row wrap>
        <div class="row-buttons">
          <v-radio-group
            v-model="filterRadio"
            class="radio-button hidden"
            row
            v-on:click="tooglePlaceholderInputSearch"
          >
            <v-radio label="CNPJ" :value="1"></v-radio>
            <v-radio label="Razão Social" :value="2"></v-radio>
          </v-radio-group>

          <input
            v-if="isText"
            type="text"
            class="general-search input-search hidden"
            :placeholder="placeholderValue"
            v-model="searchFilter.generalSearch"
          />

          <input
            v-if="isNumber"
            type="number"
            class="general-search input-search hidden"
            :placeholder="placeholderValue"
            v-model="searchFilter.generalSearch"
          />

          <div class="radio-and-input">
            <v-radio-group
              v-model="filterRadio"
              class="radio-button"
              row
              v-on:click="tooglePlaceholderInputSearch"
            >
              <v-radio label="CNPJ" :value="1"></v-radio>
              <v-radio label="Razão Social" :value="2"></v-radio>
            </v-radio-group>

            <input
              v-if="isText"
              type="text"
              class="general-search input-search"
              :placeholder="placeholderValue"
              v-model="searchFilter.generalSearch"
            />

            <input
              v-if="isNumber"
              type="number"
              class="general-search input-search"
              :placeholder="placeholderValue"
              v-model="searchFilter.generalSearch"
            />
          </div>

          <button
            id="jns"
            class="btn-primary jns-button yellow-button btn-search"
            v-on:click="filter()"
          >
            <i
              data-v-214d91de=""
              aria-hidden="true"
              class="v-icon icon-blue material-icons theme--light"
              >search</i
            >
          </button>

          <router-link
            tag="button"
            :to="{ path: '/tomadores/novo' }"
            button
            class="btn-primary jns-button yellow-button btn-add"
          >
            Cadastrar Tomador &nbsp;<v-icon>add_circle_outline</v-icon>
          </router-link>
        </div>

        <div class="layout">
          <v-data-table
            v-if="takers"
            :headers="headers"
            :items="newTakers"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 20]"
            :loading="loading"
            :no-data-text="'Nenhum tomador encontrado.'"
            :rows-per-page-text="'Linhas por página'"
            class="class-on-data-table"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td
                  class="text-xs-left sm-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/1`,
                    })
                  "
                >
                  {{ formatCNPJAndCPF(props.item.cnpj_cpf) }}
                </td>

                <td
                  class="text-xs-left xl-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/1`,
                    })
                  "
                >
                  {{ props.item.nome }}
                </td>

                <td
                  class="text-xs-center sm-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/1`,
                    })
                  "
                >
                  {{
                    formatCNPJAndCPF(props.item.cnpj_cpf_grp_economico[0])
                  }}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      <h4>Grupo Econônico</h4>
                      <p
                        v-for="(item, index) in props.item
                          .cnpj_cpf_grp_economico"
                        :key="index"
                      >
                        {{ formatCNPJAndCPF(item) }}
                      </p>
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center sm-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/2`,
                    })
                  "
                >
                  {{ toMoneyString(props.item.limite_credito_interno) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar os Limites de Créditos
                      detalhados
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center sm-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/8`,
                    })
                  "
                >
                  {{ toMoneyString(props.item.valor_total_acumulado) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar a lista de Apólices que
                      compõem este acúmulo
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center sm-column"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/2`,
                    })
                  "
                >
                  {{ toMoneyString(props.item.limite_disponivel) }}

                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-blue
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >info</i
                      >
                    </template>
                    <span>
                      Clique aqui para visualizar os Limites de Créditos
                      detalhados
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/2`,
                    })
                  "
                >
                  <v-tooltip right v-if="props.item.situacao_ccg === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span> Aprovado </span>
                  </v-tooltip>

                  <v-tooltip
                    right
                    v-if="props.item.situacao_ccg === 'Vermelho'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      Clique aqui para informações mais detalhadas da Situação
                      do tomador
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/1`,
                    })
                  "
                >
                  {{ formatDate(props.item.dt_validade_cadastro_ress) }}
                </td>

                <td
                  class="text-xs-center"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/3`,
                    })
                  "
                >
                  <v-tooltip left v-if="props.item.status_ccg === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span>
                      Clique aqui para informações mais detalhadas do CCG
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.status_ccg === 'Vermelho'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      O CCG deste tomador ainda não foi confeccionado, clique
                      aqui para preencher solicitar a assinatura do CCG
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.status_ccg === 'Amarelo'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-yellow
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      O CCG deste tomador já foi confeccionado, porém, não foi
                      Formalizado, clique aqui para informações mais detalhadas
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="text-xs-center"
                  @click="
                    $router.push({
                      path: `/tomadores/${formatCNPJAndCPFNoMask(props.item.cnpj_cpf)}/4`,
                    })
                  "
                >
                  <v-tooltip left v-if="props.item.documentacao === 'Verde'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-green
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >check_circle</i
                      >
                    </template>
                    <span> Não existe documentação pendente do tomador </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.documentacao === 'Vermelho'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-red
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span>
                      Clique aqui para acessar a tela de documentação do tomador
                    </span>
                  </v-tooltip>

                  <v-tooltip left v-if="props.item.documentacao === 'Amarelo'">
                    <template v-slot:activator="{ on, attrs }">
                      <i
                        data-v-214d91de=""
                        aria-hidden="true"
                        v-bind="attrs"
                        v-on="on"
                        class="
                          v-icon
                          icon-yellow
                          v-icon--link
                          material-icons
                          theme--light
                        "
                        >error</i
                      >
                    </template>
                    <span> A documentação enviada está sendo analisada </span>
                  </v-tooltip>
                </td>
              </tr>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              Sua pesquisa por "{{ search }}" não encontrou resultados.
            </v-alert>
          </v-data-table>
        </div>
        <div class="layout text-footer">
          <p>
            Os limites de Crédito Geral Disponível é o máximo que o Tomador
            possui para emissão em todas as modalidades, porém, ao acessar a
            tela de detalhamento de Limites e Taxas, será apresentado os Limite
            de Crédito por Grupo de Modalidades. Para Tomador que possuir Grupo
            Econômico, será considerado também o Limite Geral Disponível e o
            Limite Disponível para o Grupo de Modalidades caso configurado,
            deste Grupo Econômico.
          </p>
        </div>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { formatCNPJ, formatDate, toMoneyString, formatCNPJAndCPF,  formatCNPJAndCPFNoMask} from "@/libs/utils";

export default {
  name: "TomadorListar",
  mixins: [ViewMixin],
  data: () => ({
    formatCNPJ,
    formatDate,
    toMoneyString,
    formatCNPJAndCPF,
    formatCNPJAndCPFNoMask,
    filterRadio: 1,
    searchFilter: {
      generalSearch: "",
    },
    takers: [],
    newTakers: [],
    takersFilter: [],
    generalSearch: "",
    placeholderValue: "Digite o CNPJ do tomador",
    isText: false,
    isNumber: true,
    corretores: false,
    search: "",
    loaded: false,
    loading: false,
    pagination: {},
    headers: [
      {
        text: "CNPJ Tomador",
        align: "left",
        sortable: false,
      },
      {
        text: "Razão Social",
        align: "left",
        sortable: false,
      },
      {
        text: "CNPJ Grupo Econômico",
        align: "center",
        sortable: false,
      },
      {
        text: "Limite de Crédito Geral Aprovado",
        align: "center",
        sortable: false,
      },
      {
        text: "Valor Total Acumulado",
        align: "center",
        sortable: false,
      },
      {
        text: "Limite de Crédito Geral Disponível",
        align: "center",
        sortable: false,
      },
      {
        text: "Situação Cadastral",
        align: "center",
        sortable: false,
      },
      {
        text: "Validade Cadastro",
        align: "center",
        sortable: false,
      },
      {
        text: "Status CCG",
        align: "center",
        sortable: false,
      },
      {
        text: "Documentação",
        align: "center",
        sortable: false,
      }
    ],
  }),

  methods: {
    async init() {
      this.showLoadingIndicator();
      await this.getTakers();
      this.loaded = true;
      //array que é exibido por padrão na tela
      this.newTakers = this.takers;
    },
    
    async getTakers() {
      try {
        this.takers = await this.$store.dispatch("NEW_GET_TAKERS");
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async getTakersFilter(filter, valueRadio){
      try {
        this.showLoadingIndicator();
        this.takers =  await this.$store.dispatch("GET_TAKERS_FILTERS", this.createFilterPayload(filter, valueRadio));
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    // Altera valor do placeholder do input search
    tooglePlaceholderInputSearch(){
      if(this.filterRadio === 1 ){
        this.placeholderValue = 'Digite o CNPJ do tomador';
        this.isNumber = true;
        this.isText = false;
      } else {
        this.placeholderValue = 'Digite a razão social do tomador';
        this.isText = true;
        this.isNumber = false;
      }
    },

    filter() {
      //Campo de pesquisa
      let filters = this.searchFilter.generalSearch;

      if(filters.trim() === ''){
        return;
      }
      
      //Radio Buttons para pesquisa
      let radioFilter = this.filterRadio;

      if(radioFilter === 1){
        Promise.all([this.getTakersFilter(filters, radioFilter)]);
      }else {
        //inserir a consulta pela razão
        Promise.all([this.getTakersFilter(filters, radioFilter)]);
      }

      //Verificar se realmente é necessário executar esse interval para garantir que os dados sejam consultados
      setInterval(() => {
        let items = this.takers;

        //Caso não tenha items/takers retorna array vazio
        if (items.length === 0) {
          items = [];
        }

        return this.newTakers = items;
      }, 300);
    },
    
    createFilterPayload(filter, valueRadio){
      return {
        ...(valueRadio === 1 && {cnpj_cpf: filter}),
        ...(valueRadio === 2 && {razao_social: filter}),
      }
    }
  },

  mounted() {
    let t = this;
    t.alert = t.handleAlertText();
    t.init();
  },
};

</script>

<style lang="scss" scoped>
#jns {
  $greenColor: #38b000;
  $whiteColor: #ffffff;
  $redColor: #d00000;
  $blueColor: #282498;
  $yellowColor: #f0ed20;

  .input-group {
    padding: 0;
  }

  .icon-green {
    color: $greenColor;
    cursor: pointer;
  }

  .icon-red {
    color: $redColor;
    cursor: pointer;
  }

  .icon-blue {
    color: $blueColor;
    cursor: pointer;
  }

  .icon-yellow {
    color: $yellowColor;
    cursor: pointer;
  }

  .general-search label {
    top: 0 !important;
  }
  .jns-adicionar-novo-button {
    i {
      color: white;
    }
    &:hover {
      i {
        color: #4589f3;
      }
    }
  }

  .row-buttons {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  .radio-button {
    margin-top: 0;
    padding-top: 0;
    display: flex;
    width: 2%;
    margin-top: 24px;
  }

  .input-search {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 20px;
    width: 55%;
    background-color: $whiteColor;
    margin-right: 1%;
    border: 1px solid #ddd;
    font-size: 1.2rem;
    border-radius: 3px;
    box-shadow: 0 0 2px 0 rgba($color: #000000, $alpha: 0.2);
  }

  .input-search:focus {
    outline: 0;
  }

  .btn-search {
    width: 7%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      margin: 0;
    }
  }

  .btn-add {
    width: 22%;
    margin-left: 1%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      margin: 0;
    }
  }

  #jns .jns-button i {
    margin-left: 0 !important;
  }

  .text-footer {
    display: flex;
    padding: 20px;
    height: auto;
    background-color: #fff;
    margin-top: 1px;
    border: 1px solid rgba($color: #ddd, $alpha: 0.2);
    text-align: justify;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    word-break: break-word;

    p {
      width: 100%;
      height: auto;
    }
  }

  .radio-and-input {
    display: none;
  }

  /*
  * Responsividade dos botões e inputs de consulta
  */

  @media only screen and (max-width: 970px) {
    .btn-add {
      display: flex;
      width: 187.53px;
      height: auto;
      flex-shrink: 0;
    }
  }

  @media only screen and (max-width: 800px) {
    .input-search,
    .btn-search,
    .btn-add {
      width: 100%;
      display: block;
      margin: 1% 0 1% 0;
    }

    .hidden {
      display: none;
    }

    .radio-and-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: 100px;

      .btn-search {
        width: 60%;
        flex-shrink: 1;
      }

      .radio-button {
        display: flex;
        width: 40%;
        flex-shrink: 0;
      }

      .input-search {
        padding: 10px;
      }
    }
  }

  @media only screen and (max-width: 560px) {
    .btn-add {
      margin-bottom: 2%;
    }
  }

  @media only screen and (max-width: 361px) {
    .btn-add {
      margin-bottom: 2%;
    }
  }

  /* 
  * Valores para columns  feitos manualmente classe por classe e retirado v-flex como container da tabela
  * Adicionada classe para a div que contém a tabela para manter a responsividade da mesma em qualquer tamanho de tela
  */
  .sm-column {
    min-width: 200px;
    width: 200px;
    max-width: 200px;
  }

  .md-column {
    min-width: 300px;
    width: 350px;
    max-width: 350px;
  }

  .lg-column {
    min-width: 500px;
    width: 550px;
    max-width: 500px;
  }

  .xl-column {
    min-width: 600px;
    width: 700px;
    max-width: 800px;
  }

  .layout {
    display: inline-block;
    width: 100%;
  }

  .layout-table {
    height: auto;
    max-height: 620px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Tomadores/Listar.vue